import { Ufs } from "./enums/uf-enum";

export class NewEleitorDTO  {

    constructor(
        public login?: string,
        public email?: string,
        public senha?: string,
        public auth1?: string,
        public auth2?: string, 
        public eleicao?: any,
        public plano?: string,
        public estado?: any,
        public idGestor?: number,
        public agrupador?: string 

    ) {}
 
}